import React from "react";
import "./Text.scss";
import { FormikProps } from "formik";
import { Input } from "reactstrap";

interface InputTextProps {
  label: string;
  name: string;
  value: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  formik: FormikProps<any>;
}

const InputText = ({
  label,
  name,
  value,
  onBlur,
  error,
  touched,
  formik,
}: InputTextProps) => {
  return (
    <div className="textinput-wrapper">
      <div className="textinput-Name">{label}</div>
      <Input
        type="text"
        name={name}
        value={value}
        onChange={formik.handleChange}
        onBlur={onBlur}
        disabled={
          ["Cluster", "Category code", "* Location of the supplier"].includes(label)
        }
        className="textinput-input"
      />
      {touched && error && <div className="error-text">{error}</div>}
    </div>
  );
};

export default InputText;
